<template>
    <div class="dd-m-quiz__questions-list">
        <form v-on:submit.prevent="send()" class="dd-m-form">
            <div class="step_box gender_cards_wrpr" v-show="localStep == 1">
                <card-question
                    :offline="offline"
                    v-for="(item, index) in questions"
                    :item="item" :key="index"
                    v-show="item.is_gender_question"
                ></card-question>
            </div>
            <div class="step_box cards_wrpr" v-show="localStep > 1">
                <card-question
                    :offline="offline"
                    :stepAnswered="stepAnswered"
                    v-for="(item, index) in questions"
                    :item="item" :key="index" :itemIndex="index"
                    v-show="!item.is_gender_question && notGenderStep == index"
                    @localNextStep="notGenderNextStep"
                    @localPrevStep="notGenderPrevStep"
                    :showNextBtn="notGenderStep != questions.length-1"
                    :showPrevBtn="notGenderStep > 1"
                    :showSubmit="notGenderStep == questions.length-1"
                ></card-question>
            </div>
            <!-- <a @click="localStep = 2" class="dd-m-button dd-m-button--auto dd-m-button--assertive" v-if="localStep == 1">{{getTranslateString('Next Question')}}</a>
            <button type="submit" class="dd-m-button dd-m-button--auto dd-m-button--assertive" v-if="notGenderStep == questions.length-1">
                {{getTranslateString('Get Results')}}
            </button> -->
        </form>
    </div>
</template>
<script>

    import AuthService from '../../providers/api/auth-service';
    import QuizService from '../../providers/api/quiz-service';
    import CustomTransforms from '../../providers/transforms';
    import ScrollService from "../../providers/scroll";
    import CardQuestion from "./card-question";

    const customTransforms = new CustomTransforms(),
        quizService = new QuizService(),
        scrollService = new ScrollService(),
        authService = new AuthService();

    export default {
        name: 'quiz-questions-list',
        components: {CardQuestion},
        props: ['id', 'questions', 'offline'],
        data: () => {
            return {
            	stepAnswered: false,
                localStep: 2,
                notGenderStep: 1,
                answered_steps: {},
                answers: [],
                questionsAnswered: []
            }
        },

        mounted(){
            this.subscribe();
            this.updateOffset();

	    var gender = decodeURIComponent(window.location.search.replace('?g=', ''));
	    var translatedGender = window.Vue.prototype.getTranslateString(gender);

            
            if(gender.length) {
		var question = this.questions[0].answers.find(q => { 
			return ( q.text === translatedGender )
                });
                
                console.log("question is ", question);
                if(question) {
                    this.answers.push(question.id);
                    this.questionsAnswered.push(0);
                }
            }
        },
        methods: {
            scrollTop() {
                $('body, html')
                    .stop()
                    .animate({
                        scrollTop: 0
                    }, 500)
            },
            notGenderPrevStep() {
                this.notGenderStep -= 1;
                this.scrollTop();
                this.stepAnswered = true;
            },
            
            notGenderNextStep(){
            	console.log("this.stepAnswered", this.answered_steps);
            	if(this.answered_steps[this.notGenderStep]){
            		this.stepAnswered = true;
            	}
            	
            	if(this.stepAnswered){
            		this.answered_steps[this.notGenderStep] = true;
		            this.notGenderStep += 1;
		            this.scrollTop();
		            this.stepAnswered = false;
            	}else{
		            this.scrollTop();
		            this.showError(); 
            	}
            	
            },
            updateOffset() {
                this.questions.map((item, i) => {
                    item.offset = $(`#dd-question-${i}`).offset().top
                });
            },
            
            subscribe() {
            
                PubSub.subscribe('updateAnswers', (msg, param) => {
                	this.answered_steps[this.notGenderStep] = true;
                    this.answers = customTransforms.toggleItemOnArray(this.answers, param);
                });

                PubSub.subscribe('updateQuestionsAnswered', (msg, param) => {
                    if (param.remove) {
                        return this.questionsAnswered = this.questionsAnswered.filter(item => item !== param.value)
                    }

                    if (!this.questionsAnswered.includes(param.value)) {
                        this.questionsAnswered.push(param.value);
                    }
                });

                PubSub.subscribe('selectAnswer', (msg, param) => this.selectAnswer(param));
            },
            showError() {
                // Verifica qual é a primeira questão não respondida
                const questionsIds = this.questions.map((item) => item.id);
                const updateArr = questionsIds.filter((el) => !this.questionsAnswered.includes(el));
                const smallestNumber = Math.min(...updateArr);
                PubSub.publish('showError', smallestNumber);
            },
            send() {
                console.log('send... ');
                console.log("answers is ", this.answers);
                if (this.answers.length) {

                    // Verificamos se todas as questões foram respondidas
                    if (this.questionsAnswered.length !== this.questions.length) {
                    	console.log("not all questionsAnswered");
                        return this.showError();
                    }

                    PubSub.publish('updateQuizStep', {step: 3});

                    if (!this.offline) {

                        quizService.doSaveAnswersByQuizId(this.id, this.answers)
                            .then((res) => {

                                const isSigned = authService.isSigned();

                                if (!isSigned) {
                                    localStorage.store_quiz_id = this.id;
                                    localStorage.store_quiz_answers = this.answers;
                                }

                                // Devemos mostrar estaticamente o loading por alguns segundos
                                setTimeout(() => {
                                    PubSub.publish('updateQuizStep', {step: 4, needscope: res.data.data.data});
                                }, 2000);
                            });

                    } else {
                        const needscope = quizService.generateOfflineQuizResult(this.answers, this.questions);
                        setTimeout(() => {
                            PubSub.publish('updateQuizStep', {step: 4, needscope});
                        }, 2000);
                    }
                }
            },
            selectAnswer(index) {
                index++;
                this.stepAnswered = true;
                const el = document.getElementById(`dd-question-${index}`);

                // if (el) {
                //     scrollService.doSmoothScrollTo(`#dd-question-${index}`, 138);
                // }
            }
        }
    }
</script>

<style>
.dd-m-quiz__container {
    max-width: 100%;
    background: transparent;
}
.dd-m-quiz__questions-list,
.dd-m-quiz__content {
    background: transparent;
}
.dd-m-quiz__container .dd-m-card--quiz-question__title {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}
.dd-m-quiz__questions-list {
    border-top: 0;
}
.step_box.cards_wrpr .dd-m-card--quiz-question__item {
    width: calc(33.33% - 30px);
    margin-left: 15px;
    margin-right: 15px;
}
.step_box {
    background: #fff;
    margin-bottom: 10px;
}
.step_box.gender_cards_wrpr {
    max-width: 290px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.step_box .dd-m-button {
    padding: 0 40px;
}
@media (max-width: 1280px) {
    .step_box.cards_wrpr .dd-m-card--quiz-question__item {
        width: calc(50% - 30px);
    }
}
@media (max-width: 768px) {
    .step_box.cards_wrpr .dd-m-card--quiz-question__item {
        width: 100%;
    }
    .step_box .dd-m-button {
        padding: 0px 10px;
    }
    .dd-l-section--quiz.is-step-1 {
        padding-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/quiz-questions-list.vue